import { cn as e } from "../../shared/utils.js";
import { Button as t } from "../../button/primitive/button.js";
import { useTranslation as n } from "../../i18n/hooks.js";
import { DateRangeCustomFilterEnum as r, DateRangeFilterEnum as i } from "../types/date-range-filter-enum.js";
import { twMerge as a } from "tailwind-merge";
import { jsx as o } from "react/jsx-runtime";
//#region src/date-picker/primitive/filter-presets.tsx
function s({ className: s, disabled: c, presets: l, value: u, onChange: d }) {
	let { t: f } = n(), p = (e) => {
		switch (e) {
			case i.Last30Days: return f("public_pages_purchase.date_picker.last_30_days");
			case i.ThisMonth: return f("public_pages_purchase.date_picker.this_month");
			case i.LastMonth: return f("public_pages_purchase.date_picker.last_month");
			case r.AllTime: return f("public_pages_purchase.date_picker.all_time");
			case r.Last3Months: return f("public_pages_purchase.date_picker.last_3_months");
			case r.EvaluationPeriod: return f("public_pages_purchase.date_picker.last_pool_period");
		}
	};
	return /* @__PURE__ */ o("div", {
		className: e("tablet:flex tablet:flex-col tablet:gap-1 grid grid-cols-3 gap-2", s),
		children: l.map((e) => {
			let n = u === e;
			return /* @__PURE__ */ o(t, {
				disabled: c,
				onClick: () => {
					d(e);
				},
				size: "sm",
				variant: n ? "tertiary-color" : "ghost-gray",
				className: a("border-border-200 tablet:border-none border", n && "border-none"),
				children: p(e)
			}, e);
		})
	});
}
//#endregion
export { s as FilterPresets };
